import React from 'react';
import styled from 'styled-components';

import Input from 'components/forms/Input';
import Tooltip from 'components/Tooltip';
import InputLabel from '../common/InputLabel';
import OutputLabel from '../common/OutputLabel';
import FormRow from './FormRow';
import './occupiedRoom.style.css';

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.9em;
    color: ${({ theme }) => theme.colour.dark};
    text-align: left;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const RoomBreakdown = ({ onInputChange, formData }) => {
    const {
        numberOfRooms,
        daysOpenPerPeriod,
        averageOccupancy,
        totalRoomCountPerPeriod,
        averageOccupiedRoomCountPerPeriod,
    } = formData.roomBreakdown;
    return (
        <div>
            <Title>Room Breakdown</Title>
            <hr style={{ marginBottom: '2em' }} />
            <FormRow>
                <Tooltip title="Total number of rooms you have available" placement="right">
                    <InputLabel text="Total Number of rooms" />
                    <Input
                        type="number"
                        placeholder="0"
                        value={numberOfRooms}
                        onChange={(event) => onInputChange('numberOfRooms', event.target.value)}
                        autoFocus
                        className="occCost-form-number"
                    />
                </Tooltip>
            </FormRow>
            <FormRow>
                <Tooltip
                    title="This should be the period you can find your costs for i.e. 31 days or 365 days"
                    placement="right"
                >
                    <InputLabel text="Days open per period" />
                    <Input
                        type="number"
                        value={daysOpenPerPeriod}
                        onChange={(event) => onInputChange('daysOpenPerPeriod', event.target.value)}
                        placeholder="0"
                        max="366"
                        required
                        className="occCost-form-number"
                    />
                    <OutputLabel text={totalRoomCountPerPeriod} />
                </Tooltip>
            </FormRow>
            <FormRow>
                <Tooltip title="Your average occupancy" placement="right">
                    <InputLabel text="Average Occupancy" />
                    <Input
                        type="number"
                        value={averageOccupancy}
                        onChange={(event) => onInputChange('averageOccupancy', event.target.value)}
                        placeholder="0"
                        max="100"
                        required
                        className="occCost-form-number"
                        addonAfter="%"
                    />
                    <OutputLabel text={averageOccupiedRoomCountPerPeriod.toFixed(0)} />
                </Tooltip>
            </FormRow>
        </div>
    );
};

export default RoomBreakdown;
